/**
 * Extract N-value from a browse redirect path (e.g., '/b/...')
 * @param {string} path - The redirect path
 * @returns {string|null} - The extracted N-value or null
 */
export const getNvalue = (path) => {
  const pathArr = path.split('/');
  const fullNValue = pathArr.find((part) => part.startsWith('N-') || part.startsWith('Ntt-'));
  if (fullNValue) {
    const nValue = fullNValue.split('?')?.[0];
    if (nValue.startsWith('N-')) {
      return nValue.slice(2);
    }
    return nValue.slice(4);
  }
  return null;
};

/**
 * Extract new keyword from a search redirect path (e.g., '/s/...')
 * @param {string} path - The redirect path
 * @returns {string|null} - The extracted keyword or null
 */
export const getNewKeyword = (path) => {
  const pathArr = path.split('/');
  const indexOfs = pathArr.findIndex((part) => part === 's');
  const keywordPart = pathArr?.[indexOfs + 1];
  if (keywordPart) {
    const keywordArr = keywordPart.split('?');
    return keywordArr?.[0] || null;
  }
  return null;
};
